import React from "react";
import BannerBG from "../../../assets/about-banner-bg.png";
import defaultBannerIMG from "../../../assets/about-banner-image.png";

function AboutBannerSection({ acfData }) {
  // Fallback values
  const defaultTitle = "About Us";
  const defaultDetail =
    "Boosting the Indigenous economy by keeping more tourism, retail and hospitality dollars on Indigenous land.";
  const defaultImage = defaultBannerIMG;

  // Extracted from API or fallback
  const title = acfData?.about_us_title || defaultTitle;
  const detail = acfData?.about_us_detail || defaultDetail;
  const image = acfData?.about_us_image || defaultImage;

  return (
    <section
      className="py-10"
      style={{
        backgroundImage: `url(${BannerBG})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="w-full max-w-[1570px] px-4 mx-auto">
        <div className="flex flex-wrap items-center -mx-4">
          {/* Text */}
          <div className="w-full lg:w-1/2 max-w-full px-4 text-center lg:text-left">
            <div className="lg:max-w-[671px]">
              <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2] mb-4">
                {title}
              </h3>
              <p className="text-lg font-light leading-7 text-[#333333] mb-8 lg:mb-0">
                {detail}
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="w-full lg:w-1/2 max-w-full px-4">
            <img
              src={image}
              alt="About Us"
              className="mr-auto lg:mr-0 ml-auto"
              height="493"
              width="805"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutBannerSection;
